import dayjs from 'dayjs';
import Text from '../../../../components/detail/components/Text.component';
import { Box, Paper } from '@mui/material';
import SailingIcon from '@mui/icons-material/Sailing';
import { Status } from '../../../booking/conf/Data.conf';
import _ from 'lodash';
import RectangleChip from '../../../../components/common/RectangleChip.component';

export const DetailConf = {
  initialState: {
    loading: false,
    error: null,
    data: null,
    meta: null,
  },
  fields: [
    {
      type: 'text',
      label: 'Check In',
      key: 'attributes',
      xs: 12,
      sm: 4,
      md: 2,
    },
    {
      type: 'text',
      label: 'Check Out',
      key: 'attributes.check_out_date',
      xs: 12,
      sm: 4,
      md: 2,
    },
    {
      type: 'text',
      label: 'Nights',
      key: 'attributes.booking_days',
      xs: 12,
      sm: 4,
      md: 2,
      variant: 'subtitle2',
    },
    {
      type: 'text',
      label: 'Marina',
      key: 'attributes.id_marina.data.attributes.marina',
      xs: 12,
      sm: 4,
      md: 2,
      variant: 'subtitle2',
    },
    {
      type: 'text',
      label: 'Location',
      key: 'attributes.id_marina.data.attributes.location',
      xs: 12,
      sm: 4,
      md: 2,
      variant: 'subtitle2',
    },
    {
      type: 'text',
      label: '',
      key: 'attributes.booking_status',
      xs: 12,
      sm: 4,
      md: 2,
    },
    {
      type: 'text',
      label: '',
      key: 'attributes.note2',
      xs: 12,
    },
  ],
  formatValue: (key, value) => {
    switch (key) {
      case 'attributes':
        return (
          <Box
            sx={{
              display: 'flex',
              height: '100%',
              alignItems: 'center',
            }}
          >
            <Text
              variant='subtitle2'
              label='Check In'
              value={dayjs(value?.check_in_date).format('DD-MM-YYYY')}
            />
            {value?.incoming && (
              <Box
                sx={{
                  ml: 1,
                  animation: 'blinker 1.5s linear infinite',
                  '@keyframes blinker': {
                    '50%': { opacity: 0 },
                  },
                }}
              >
                <SailingIcon fontSize='small' sx={{ color: 'primary.main' }} />
              </Box>
            )}
          </Box>
        );
      case 'attributes.check_out_date':
        return (
          <Text
            variant='subtitle2'
            label='Check Out'
            value={dayjs(value).format('DD-MM-YYYY')}
          />
        );
      case 'attributes.booking_status':
        const color = _.find(
          Status,
          (item) => item.label.toUpperCase() === value.toUpperCase()
        );
        return (
          <RectangleChip
            value={value || '-'}
            size='small'
            backgroundColor={color?.hex}
            color={'#fff'}
            sx={{
              ml: 1,
              boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
              borderRadius: 1,
            }}
            fontSize='0.75rem'
            fontWeight={600}
            width={'auto'}
          />
        );
      case 'attributes.note2':
        if (!value) return null;
        return (
          <Paper
            elevation={0}
            sx={{
              px: 1,
              mt: 0.5,
              width: '100%',
              background:
                'linear-gradient(135deg,rgb(255, 217, 159) 0%,rgb(253, 237, 185) 100%)',
              borderRadius: 1,
              border: '1px solid rgba(0,0,0,0.05)',
            }}
          >
            <Text variant='subtitle2' label='Note 2' value={value} />
          </Paper>
        );
      default:
        return null;
    }
  },
};
